import { useEffect, useState } from "react";
import "../../assets/styles/Profile/Profile.css";
import "../../assets/styles/products/product.css";
import NavbarHome from "../home/NavbarNew/NavbarHome";
// import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, decreaseQuantity, removeFromCart, clearCart } from "../../redux/actions/cart/cart.actions";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";

const MyCart = () => {

const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const [cartItems, setCartItems] = useState([])

  useEffect(() => {
    setCartItems(cart.items)
  }, [cart])

  const handleRemoveItem = (id) => {
    dispatch(removeFromCart(id))
  }

  const handleIncrease = (product) => {
    dispatch(addToCart(product));
  };

  const handleDecrease = (productId) => {
    dispatch(decreaseQuantity(productId));
  };

  const handleClearCart = (productId) => {
    dispatch(clearCart(productId));
  };

  return (

    <div className="bg-white d-flex flex-column" style={{ height: '100dvh' }}>
      <NavbarHome />
      <div className="px-3 flex-grow-1">

        {/* <Catalogue/> */}
        {!cart ?
          <p className=" fs-6 text-capitalize rounded text-center pt-1" style={{ backgroundColor: "#ececec", width: "105px", height: "86px", marginBottom: "-1px" }}>No Product</p>
          :
    <div className="container py-4">
      {/* Header */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h4 className="mb-0 fw-semibold">My Cart</h4>
          <small className="text-muted">
            Review your items before checkout
          </small>
        </div>
      </div>

      <div className="row">
        {/* Cart Items */}
        <div className="col-lg-8">
          {cartItems.map((item) => (
            <div className="card shadow-sm mb-3" key={item.id}
              onClick={()=>navigate(`/product/${item?.productId}`, { state: { item: item.productId }})}
              style={{cursor: 'pointer'}}
            >
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <img
                    src={item.image}
                    alt={item.productName}
                    className="rounded"
                    style={{ width: 90, height: 90, objectFit: "cover" }}
                  />

                  <div className="ms-3 flex-grow-1">
                    <h6 className="mb-1">{item.productName}</h6>
                    <small className="text-muted">
                      USD ${item.price.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}
                    </small>

                    <div className="d-flex align-items-center mt-2">
                      <div className="d-flex align-items-center border rounded px-2" onClick={(e) => e.stopPropagation()}>
                        <button
                          className="btn btn-sm btn-light qty-btn"
                          onClick={(e) => handleDecrease(item.productId)}
                          disabled={item.quantity <= 1}
                        >
                          −
                        </button>

                        <span className="mx-2 fw-semibold">
                          {item.quantity}
                        </span>

                        <button
                          className="btn btn-sm btn-light qty-btn"
                          onClick={(e) => handleIncrease(item)}
                        >
                          +
                        </button>
                      </div>

                      <button
                        className="btn btn-link text-danger ms-3 p-0"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveItem(item.productId);
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>

                  <div className="fw-semibold">
                    USD ${(item.price * item.quantity).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Order Summary */}
        <div className="col-lg-4">
          <div className="card shadow-sm position-sticky" style={{ top: 20 }}>
            <div className="card-body">
              <h5 className="mb-3">Order Summary</h5>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Subtotal</span>
                <span>USD ${cart.totalAmount.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Shipping & handling</span>
                <span>USD ${cart.items.reduce((accumulator, currentItem) => { return accumulator + (currentItem.shippingCost*currentItem.quantity)}, 0).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                </span>
              </div>

              <hr />

              <div className="d-flex justify-content-between fw-semibold mb-3">
                <span>Total</span>
                <span>USD ${ cart.items.length > 0 ? 
                  (cart.totalAmount + cart.items.reduce((accumulator, currentItem) => { return accumulator + (currentItem.quantity*currentItem.shippingCost);}, 0)).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "00.00"}
                </span>
              </div>

              <Button className="btn w-100 btn-ibouge" onClick={() => cart.items.length > 0 ? navigate('/checkout') : navigate("/")}>
                {cart.items.length > 0 ? "Proceed to Checkout": "Back to Home Page"}
              </Button>

              <p className="mt-2 pb-0 text-end text-decoration-underline text-primary cursor-pointer" onClick={()=> handleClearCart()}>clear cart</p>
            </div>
          </div>
        </div>
      </div>
    </div>
        }
      </div>
      <FootNav />
    </div>
  );
};

export default MyCart;